import React, { useRef } from 'react';

import { Button } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PropTypes from 'prop-types';

import IconExcel from '~/assets/icons/icons8-ms-excel.svg';
import { IconButton } from '~/components';
import { Form, DateTime, Autocomplete } from '~/components/Form';
import { t } from '~/helpers';

import * as S from './styles';

function Header({ data, loading, handleSubmit, canExport, onExportClick }) {
  const formRef = useRef(null);

  return (
    <Form ref={formRef} initialData={data} onSubmit={handleSubmit}>
      <S.WrapperForm>
        <div className="linha-filtros">
          <div className="field-date">
            <DateTime
              time
              name="datainicio"
              label={t('s.geral.opcoes.datahorainicial')}
              serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            />
          </div>

          <div className="field-date">
            <DateTime
              time
              name="datafim"
              label={t('s.geral.opcoes.datahorafinal')}
              serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            />
          </div>

          <div className="field-autocomplete">
            <Autocomplete
              name="idposto"
              label="codigonomeposto"
              url="postoscomboios"
              unique="idposto"
              title={t('s.geral.postocomboio')}
              params={{
                fieldlist: 'idposto, codigonomeposto',
              }}
              hiddens={[{ name: 'codigonomeposto' }]}
            />
          </div>

          <div className="row-botoes">
            <Button
              size="medium"
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              fullWidth={false}
              style={{ minWidth: 100 }}
            >
              {t('s.geral.pesquisar')}
            </Button>

            <IconButton
              type="button"
              startIcon={
                <PictureAsPdfIcon
                  style={{ color: 'white', width: 20, height: 20 }}
                />
              }
              backgroundColor="#d32f2f"
              color="white"
              iconSize={20}
              onClick={() => onExportClick('PDF')}
              style={{ minWidth: 40, width: 40, maxWidth: 40 }}
              disabled={!canExport || loading}
            />

            <IconButton
              type="button"
              startIcon={
                <img
                  src={IconExcel}
                  alt="Excel"
                  style={{
                    width: 20,
                    height: 20,
                    filter: 'invert(1)',
                  }}
                />
              }
              backgroundColor="#2e7d32"
              color="white"
              iconSize={20}
              onClick={() => onExportClick('EXCEL')}
              style={{ minWidth: 40, width: 40, maxWidth: 40 }}
              disabled={!canExport || loading}
            />
          </div>
        </div>
      </S.WrapperForm>
    </Form>
  );
}

Header.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canExport: PropTypes.bool.isRequired,
  onExportClick: PropTypes.func.isRequired,
};

export default Header;
